import { Outlet } from "react-router"
import { Toaster } from "sonner"

import AppHeader from "./AppHeader.tsx"
import AppSidebar from "./AppSidebar.tsx"
import { ScrollArea } from "./ui/scroll-area.tsx"
import { SidebarInset, SidebarProvider } from "./ui/sidebar.tsx"

export default function BaseLayout() {
  return (
    <SidebarProvider>
      <Toaster position="top-center" closeButton={true} />
      <AppSidebar />
      <SidebarInset
        className="overflow-y-hidden h-[calc(100vh-16px)] box-border "
        style={{ background: "var(--app-canvas)" }}
      >
        <AppHeader />
        <div className="overflow-y-hidden overflow-x-clip grow max-w-full min-w-0">
          <ScrollArea
            className="flex flex-col h-full min-w-0 w-full items-stretch"
            id="scrollContainer"
          >
            <div className="p-4 min-w-0">
              <Outlet />
            </div>
          </ScrollArea>
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
